import { Navigate, RouteObject } from 'react-router-dom';
import { PATH_GLMS_PLAYER, PATH_MAIN } from 'src/routes/paths';
import { MainContainer } from 'src/containers/main-container';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

/**
 * @description - The route of the main functionality
 */
const mainRoutes: RouteObject = {
  path: PATH_MAIN.root,
  element: <MainContainer />,
  children: [
    {
      element: <Navigate
        to={PATH_GLMS_PLAYER.classes.root}
        replace
      />,
      index: true
    }
  ]
};

export default mainRoutes;
